<template>
  <el-dialog
    :title="title"
    :visible.sync="dialogImportClient"
    :before-close="doClose"
    width="70%"
    top="5vh"
  >
    <el-form
      :ref="refForm"
      :model="form"
      :label-width="$t('language.name') == '中文' ? '150px' : '200px'"
    >
      <el-form-item>
        <el-upload
          ref="uploadExcel"
          style="margin-bottom: 10px"
          action="#"
          :auto-upload="false"
          :file-list="fileList"
          :on-change="onUploadChange"
          :limit="limitNum"
          :on-success="handleSuccess"
          :on-exceed="exceedFile"
          :on-error="handleError"
          :before-upload="onBeforeUpload"
          :on-remove="remove"
          accept=".xls,.xlsx"
        >
          <el-button size="small">{{ $t("button.chooseFile") }}</el-button>
          <div slot="tip" class="el-upload__tip">{{ msg }}</div>
        </el-upload>
      </el-form-item>
      <el-form-item>
        <el-button size="small" type="primary" @click="uploadFile(refForm)">{{
          $t("button.startImport")
        }}</el-button>
        <el-button size="small" @click="doClose">{{
          $t("button.cancel")
        }}</el-button>
      </el-form-item>
    </el-form>
  </el-dialog>
</template>
<script>
import XLSX from "xlsx";
export default {
  name: "index",
  props: {
    refForm: "",
    subButtonAuth: false,
    dialogImportClient: false,
    title: "",
    form: {
      datalist: [],
    },
    msg: "",
  },
  data() {
    return {
      limitNum: 1,
      fileList: [],
    };
  },
  methods: {
    doClose() {
      this.$emit("dialogVisibleEvent", false);
      this.$refs[this.refForm].resetFields();
    },
    exceedFile(files, fileList) {
      this.$notify.warning({
        title: this.$t("tips.warning"),
        message: `只能选择 ${this.limitNum} 个文件，请先删除文件后重新选择`,
      });
    },
    onUploadChange(file) {
      let that = this;

      const sheet2JSONOpts = {
        /** Default value for null/undefined values */
        defval: "", //给defval赋值为空的字符串
      };
      var file = file.raw;
      // var rABS = true; //是否将文件读取为二进制字符串
      var reader = new FileReader();
      FileReader.prototype.read = function (file) {
        var binary = "";
        var wb; //读取完成的数据
        // var outdata;

        var reader = new FileReader();

        reader.onload = function (e) {
          var bytes = new Uint8Array(reader.result);

          var length = bytes.byteLength;

          for (var i = 0; i < length; i++) {
            binary += String.fromCharCode(bytes[i]);
          }

          wb = XLSX.read(binary, {
            type: "binary",
          });
          var list = [];
          // outdata就是你想要的东西 excel导入的数据
          wb.SheetNames.forEach((e, index) => {
            var data = XLSX.utils.sheet_to_json(
              wb.Sheets[wb.SheetNames[index]],
              sheet2JSONOpts
            );
            var model = {
              sheetName: wb.SheetNames[index],
              data: data,
            };
            list.push(model);
          });
          that.form.datalist = list;
          // this.form.datalist =outdata;
        };

        reader.readAsArrayBuffer(file);
      };
      reader.read(file);
    },

    uploadFile(value) {
      if (this.form.datalist.length == 0) {
        this.$message({
          showClose: true,
          message: "请选择要导入的文件",
          type: "error",
        });
        return false;
      } else {
        this.$emit("onSubBtn", true);
        this.fileList = [];
      }
    },
    handleSuccess(res, file) {
      this.$notify.success({
        title: "成功",
        message: `导入成功`,
      });
    },
    handleError(err, file) {
      this.$notify.error({
        title: "错误",
        message: `导入失败`,
      });
    },
    onBeforeUpload(file) {
      let extension = file.name.substring(file.name.lastIndexOf(".") + 1);
      let size = file.size / 1024 / 1024;
      if (extension !== "xlsx" && extension !== "xls") {
        this.fileList = [];
        this.$notify.warning({
          title: this.$t("tips.warning"),
          message: `只能选择xlsx、xls的文件`,
        });
        return false;
      }
      this.fileList = [{ uid: file.uid, name: file.name, status: "success" }];
      return true;
    },
    remove(file) {
      this.fileList = [];
      this.form.datalist = [];
    },
  },
};
</script>

<style scoped>
#formPer .el-form-item__content {
  line-height: 35px;
  border-left: 1px solid #ebeef5;
  padding-left: 10px;
}

#formPer > .el-form-item {
  margin-bottom: 0px;
  border-bottom: 1px solid #ebeef5;
}

#formPer .noborder .el-form-item__content {
  border: 0;
}

#formPer .noborder {
  border: 0;
  margin-top: 20px;
}
</style>
